import { createBoxKitchenAppliance } from "./C1_createBoxKitchenAppliance";

const Refrigerator = createBoxKitchenAppliance({
  id: "refrigerator",
  iconKind: "refrigerator",
  description: { en: "Refrigerator", de: "Kühlschrank" },
  centerLabel: { en: "R", de: "K" },
});

export default Refrigerator;
